import type { PlayoffStructure } from '../model/Season';

/**
 * Read playoffStructure from parsed season JSON (import or API).
 * Matches validation used when loading season from the server.
 */
export function extractPlayoffStructureFromImport(importedData: unknown): PlayoffStructure | undefined {
    if (!importedData || typeof importedData !== 'object') return undefined;
    const ps = (importedData as { playoffStructure?: unknown }).playoffStructure;
    if (!ps || typeof ps !== 'object') return undefined;
    const p = ps as Record<string, unknown>;
    if (
        typeof p.divisionWinnersPerDivision !== 'number' ||
        typeof p.wildcardCount !== 'number' ||
        typeof p.byeCount !== 'number'
    ) {
        return undefined;
    }
    return ps as PlayoffStructure;
}
